import React from 'react';
import {
  Table,
  TableContainer,
  Th,
  Td
} from './styled';

export const PublicationClosingDates: React.FC = () => {
  return (
    <TableContainer className={'contenedor'}>
      <Table>
        <thead>
          <tr>
            <Th colSpan={2} rowSpan={2}>Producto</Th>
            <Th colSpan={7}>Publicación Clasificados</Th>
          </tr>
          <tr>
            <Th>Lunes</Th>
            <Th>Martes</Th>
            <Th>Miércoles</Th>
            <Th>Jueves</Th>
            <Th>Viernes</Th>
            <Th>Sábado</Th>
            <Th>Domingo</Th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <Td style={{backgroundColor: 'orange'}}><strong>Trome</strong></Td>
            <Td rowSpan={4} className={'black'}><strong>Cierre Comercial</strong></Td>
            <Td>Viernes 6pm</Td>
            <Td>Viernes 6pm</Td>
            <Td>Lunes 6pm</Td>
            <Td>Martes 6pm</Td>
            <Td>Miércoles 6pm</Td>
            <Td>Jueves 6pm</Td>
            <Td>Viernes 6pm</Td>
          </tr>
          <tr>
            <Td style={{backgroundColor: 'green'}}><strong>Depor</strong></Td>
            <Td>Viernes 6pm</Td>
            <Td>Viernes 6pm</Td>
            <Td>Lunes 6pm</Td>
            <Td>Martes 6pm</Td>
            <Td>Miércoles 6pm</Td>
            <Td>Jueves 6pm</Td>
            <Td>Viernes 6pm</Td>
          </tr>
          <tr>
            <Td style={{backgroundColor: 'blue'}}><strong>Perú 21</strong></Td>
            <Td>Viernes 6pm</Td>
            <Td>Viernes 6pm</Td>
            <Td>Lunes 6pm</Td>
            <Td>Martes 6pm</Td>
            <Td>Miércoles 6pm</Td>
            <Td>Jueves 6pm</Td>
            <Td>Viernes 6pm</Td>
          </tr>
          <tr>
            <Td style={{backgroundColor: 'yellow'}}><strong>EC</strong></Td>
            <Td>Viernes 5pm</Td>
            <Td>Lunes 5pm</Td>
            <Td>Martes 5pm</Td>
            <Td>Miércoles 5pm</Td>
            <Td>Jueves 5pm</Td>
            <Td>Viernes 12pm</Td>
            <Td>Viernes 6pm</Td>
          </tr>
        </tbody>
      </Table>
    </TableContainer>
  )
};